// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__yUPW4","column":"style_column__182Q5"};